import { Helmet } from "react-helmet-async";
import envConstants from "../Constants";
import { Link } from "react-router-dom";
const Feedback = () => {
    const canonicalUrl = 'https://autopartstation.com.au/feedback';
    const schemaMarkup = {
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "Feedback - Auto Part Station",
        "url": "https://autopartstation.com.au/feedback",
        "mainEntity": {
            "@type": "Organization",
            "name": "Auto Part Station Pty Ltd",
            "url": "https://autopartstation.com.au",
            "logo": "https://autopartstation.com.au/auto-part.png"
        }
    };
    return (
        <div className="container my-4">
            <Helmet>
                <title>Feedback - Auto Part Station | Share Your Experience</title>
                <meta name="description" content="Share your feedback with Auto Part Station. We value your input to improve our services and product offerings!" />
                <meta name="author" content={envConstants.STORE_META_AUTHOR ? envConstants.STORE_META_AUTHOR : 'Auto Part Station Store'} />
                <meta name="keywords" content="Auto Part Station Feedback, Feedback Auto Part Station" />
                <link rel="canonical" href={canonicalUrl} />
                <script type="application/ld+json">
                    {JSON.stringify(schemaMarkup)}
                </script>
            </Helmet>
            <h2>Feedback & Complaints</h2>
            <p>At <Link to="/" style={{color: "black", textDecoration: "none"}}>Auto Part Station</Link>, we greatly appreciate your feedback as it plays a crucial role in helping us enhance our services. We welcome both positive comments and any concerns or complaints you may have. If you would like to provide feedback or raise a complaint, please choose from the following options:</p>
            <h5>Write to Us</h5>
            <p>You can send us an email at <a href="mailto:sales@autopartstation.com.au" className="text-decoration-none text-dark fw-bold">sales@autopartstation.com.au</a> with your feedback or complaint.</p>
            <h5>Online Form</h5>
            <p>Feel free to use our <a href="/contact-us" className="text-decoration-none text-dark fw-bold">Contact Us</a> form online to submit your feedback.
                <br />
                <br />
                When reaching out, please include enough details for us to identify you, such as your account information or order number. Clearly explain the subject of your complaint or feedback, and let us know how you would like your concern to be addressed.
            </p>
            <h5>Our Process</h5>
            <p>Once we receive your feedback or complaint, we will take the following steps:</p>
            <ol>
                <li>Acknowledge receipt of your communication within 3 business days.</li>
                <li>Contact you for any additional information, if necessary.</li>
                <li>Thoroughly assess and investigate your concerns.</li>
                <li>Strive to resolve your complaint fairly and objectively.</li>
                <li>Aim to provide a resolution within 30 days.</li>
                <li>Inform you of our decision and the reasons behind it.</li>
            </ol>
            <p>
                Our goal is to address your complaint to your satisfaction and enhance your experience with Auto Part Station.
                <br />
                <br />
                We appreciate your input and assure you that we will do our best to respond promptly and effectively.
            </p>
        </div>
    )
}

export default Feedback;